import script from "./MainStore.vue?vue&type=script&setup=true&lang=js"
export * from "./MainStore.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__